// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".giveaway-partner__image[data-v-23a42f50]{height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
